<template>

  <b-form-group
    :label="label"
    :label-for="id"
    class="bold-label mb-4"
    :state="textAreaValue.state"
    :invalid-feedback="textAreaValue.invalidFeedback">
    <div v-if="info">{{info}}</div>
    <b-form-textarea
      :id="id"
      v-model="textAreaValue.value"
      type="text"
      :maxlength="maxLength"
      :placeholder="placeholder"
      :required="isRequired"
      :disabled="isDisabled"
      :state="textAreaValue.state"
      v-on:change="removeInvalidFeedback">
    </b-form-textarea>
    <b-form-text>{{helpMessage}}</b-form-text>
  </b-form-group>

</template>

<script>
export default {
  name: 'TextAreaField',

  props: {
    textAreaValue: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: 'input'
    },
    maxLength: {
      type: Number,
      default: 1000
    },
    placeholder: {
      type: String,
      default: null
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    info: {
      type: String,
      default: null
    },
    helpMessage: {
      type: String,
      default: null
    }
  },

  methods: {

    removeInvalidFeedback () {
      this.textAreaValue.state = null
      this.textAreaValue.invalidFeedback = null
    }

  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/b122/editFields/TextAreaField.vue